/**
 * DataZoom 滑动条移动手柄垂直偏移功能扩展
 *
 * 功能说明:
 * - 通过 dvMoveHandleOffset 配置项控制 DataZoom 滑动条中间移动区域的垂直位置偏移
 * - 允许开发者微调滑动条移动手柄的垂直位置，以适应不同的设计需求
 * - 偏移值为数字类型，正值向下偏移，负值向上偏移
 *
 * 使用示例:
 * ```typescript
 * dataZoom: \{
 *   type: 'slider',
 *   dvMoveHandleOffset: 5  // 向下偏移 5px
 * \}
 * ```
 */

import SliderDataZoomView from 'echarts/lib/component/dataZoom/SliderZoomView';
import type { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type { Displayables, DvSliderDataZoomModel, MoveHandleOffset } from './type';
import { isValidNumericValue } from './util';

// 保存原始的 _renderHandle 方法引用
// @ts-ignore
const originRenderHandleMethod = SliderDataZoomView.prototype._renderHandle as () => void;

/**
 * 应用移动手柄垂直偏移效果
 * @param moveHandleOffset - 移动手柄偏移量（正值向下，负值向上）
 * @param size - DataZoom 尺寸数组 [width, height]
 * @param moveZone - 移动区域显示对象
 */
function $renderHandle(
  moveHandleOffset?: MoveHandleOffset,
  size?: number[],
  moveZone?: Displayables['moveZone']
) {
  // 验证参数有效性
  if (!moveHandleOffset || !moveZone || !(size && size.length)) {
    return;
  }
  if (!isValidNumericValue(moveHandleOffset)) {
    return;
  }
  
  // 计算垂直偏移位置：从中心位置减去偏移量
  const half = 0.5;
  moveZone.attr({
    shape: {
      y: size[1] * half - moveHandleOffset
    }
  });
}

/**
 * 重写 SliderDataZoomView 的 _renderHandle 方法
 * 在原有渲染逻辑基础上添加移动手柄垂直偏移功能
 */
// @ts-ignore
SliderDataZoomView.prototype._renderHandle = function renderHandle() {
  // 获取 dvMoveHandleOffset 配置项
  // @ts-ignore
  const dvMoveHandleOffset = (this?.dataZoomModel as DvSliderDataZoomModel)?.get(
    'dvMoveHandleOffset'
  );
  // @ts-ignore
  const size = this._size as number[];

  // 先调用原始渲染方法
  originRenderHandleMethod.call(this);

  // 应用移动手柄偏移效果
  // @ts-ignore
  $renderHandle(dvMoveHandleOffset, size, (this?._displayables as Displayables)?.moveZone);
};

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {});
}
